import { render, staticRenderFns } from "./UnpaidDebtorList.vue?vue&type=template&id=3855ea7d&scoped=true&"
import script from "./UnpaidDebtorList.vue?vue&type=script&lang=js&"
export * from "./UnpaidDebtorList.vue?vue&type=script&lang=js&"
import style0 from "./UnpaidDebtorList.vue?vue&type=style&index=0&id=3855ea7d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3855ea7d",
  null
  
)

export default component.exports